import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

/** Je li nalog otvoren (vozilo još nije preuzeto) ili zatvoren. */
export const SERVICE_OPEN_OPTIONS: DropdownOption[] = [
  { value: "true", text: "Otvoreni nalozi" },
  { value: "false", text: "Zatvoreni nalozi" },
];
